import styled, {
  keyframes,
} from 'styled-components';

import blackLogo from 'web-assets/images/logo-monoblack.png';
import Icon from 'web-components/Icon';

const placeholder = keyframes`
  0% {
    opacity: 0.4;
  }
  50% {
    opacity: 0.8;
  }
  100% {
    opacity: 0.4;
  }
`;

type FlexProps = {
  position?: string,
  column?: boolean,
  wrap?: string,
  justify?: string,
  align?: string,
  spacing?: number | string,
  fillSpace?: boolean,
  flex?: string,
  width?: number | string,
  height?: number | string,
  minHeight?: string,
  padding?: string,
  margin?: string,
  grow?: number | string,
  shrink?: number | string,
  alignSelf?: string,
  border?: string,
  borderRadius?: string,
  borderTop?: string,
  borderBottom?: string,
  borderRight?: string,
  borderLeft?: string,
  background?: string,
  maxWidth?: string,
  overflow?: string,
  noScroll?: boolean,
  scrollX?: boolean,
  scrollY?: boolean,
  clickable?: boolean,
  noPrint?: boolean,
  disabled?: boolean,
  placeholder?: boolean,
};

export const Flex = styled.div<FlexProps>`
  display: flex;
  position: ${props => props.position || 'relative'};
  flex-wrap: ${props => props.wrap || 'nowrap'};
  flex-direction: ${props => (props.column ? 'column' : 'row')};
  justify-content: ${props => props.justify || 'flex-start'};
  align-items: ${props => props.align || 'flex-start'};
  box-sizing: border-box;
  ${props => props.spacing && `
    & > *:not(:last-child) {
      margin-${(props.column ? 'bottom' : 'right')}: ${props.spacing}px;
    }
  `};
  ${props => props.fillSpace && `
    height: 100%;
    width: 100%;
    flex: 1 1 100%;
  `}
  ${props => props.flex && `
    flex: ${props.flex};
  `};
  ${props => props.height && `
    height: ${typeof props.height === 'number' ? `${props.height}px` : props.height};
  `};
  ${props => props.width && `
    width: ${typeof props.width === 'number' ? `${props.width}px` : props.width};
  `};
  ${props => props.minHeight && `
    min-height: ${props.minHeight};
  `};
  ${props => props.padding && `
    padding: ${props.padding};
  `};
  ${props => props.margin && `
    margin: ${props.margin};
  `};
  ${props => props.grow !== undefined && `
    flex-grow: ${props.grow};
  `};
  ${props => props.shrink !== undefined && `
    flex-shrink: ${props.shrink};
  `};
  ${props => props.alignSelf && `
    align-self: ${props.alignSelf};
  `};
  ${props => props.placeholder && `
    animation: ${placeholder} 1.5s ease infinite;
  `};
  ${props => props.borderRadius && `
    border-radius: ${props.borderRadius};
  `};
  ${props => props.border && `
    border: ${props.border};
  `};
  ${props => props.borderTop && `
    border-top: ${props.borderTop};
  `};
  ${props => props.borderBottom && `
    border-bottom: ${props.borderBottom};
  `};
  ${props => props.borderRight && `
    border-right: ${props.borderRight};
  `};
  ${props => props.borderLeft && `
    border-left: ${props.borderLeft};
  `};
  ${props => props.background && `
    background: ${props.background};
  `};
  ${props => props.color && `
    color: ${props.color};
  `};
  ${props => props.maxWidth && `
    max-width: ${props.maxWidth};
  `};
  ${props => props.overflow && `
    overflow: ${props.overflow};
  `};
  ${props => props.noScroll && `
    overflow: visible;
    @media print {
      height: auto;
      width: 100%;
      overflow-y: visible;
      overflow-x: visible;
    }
  `};
  ${props => props.scrollX && `
    overflow-y: hidden;
    overflow-x: auto;
    @media print {
      overflow: visible;
    }
  `};
  ${props => props.scrollY && `
    overflow-x: hidden;
    overflow-y: auto;
    @media print {
      overflow: visible;
    }
  `};
  ${props => props.clickable && `
    cursor: pointer;
  `};
  ${props => props.noPrint && `
    @media print {
      display: none;
    }
  `};
`;

export const Container = styled(Flex)`
  width: 960px;
  margin: ${props => props.margin || '0 auto'};

  @media (min-width: 1141px) {
    width: 1140px;
  }

  @media (max-width: 960px) {
    flex-wrap: wrap;
    width: 100%;
    margin: 0;
    padding: 0 15px;
    justify-content: center;
  }
`;

export const WorkoutExercisesView = styled(Flex).attrs({
  column: true,
  shrink: '0',
})`
  width: 100%;
  margin: 0 0 15px;
  border: 1px solid #ededed;
  border-radius: 10px;

  @media print {
    border: none;
    height: auto;
    width: 100%;
    display: block;
  }

  ${props => props.disabled && `
    position: relative;
    opacity: 0.55;
    &:after {
      content: '';
      display: block;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      border-radius: 10px;
    }
  `}
`;

export const PrintLogo = styled.img.attrs({
  src: blackLogo,
  alt: '',
})`
  display: none;
  @media print {
    display: block;
    margin-right: 1%;
  }
`;

export const RoundImg = styled.img<{ size: string }>`
  display: block;
  width: ${props => props.size || '100%'};
  height: ${props => props.size || '100%'};
  border: 1px #fff solid;
  border-radius: 50%;
`;
